<template>
  <div class="iiko-input-wrapper iqos-group-item">
    <img src="https://cdn.qrwaiter.com.ua/assets/integrations/iiko.jpg" class="iiko-logo" v-if="show_logo">
    <div class="w-100" v-if="selectedProduct">
      <BaseInput
        rightIcon="x"
        leftIcon="link"
        icon="link"
        iconPosition="both"
        disabled
        fullWidth
        @iconClicked="resetSelection"
        :value="selectedProduct.name"
        >
      </BaseInput>
    </div>
    <div class="iiko-input-edit" v-else>
      <BaseSearchInput
        fullWidth
        type="text"
        icon="search"
        iconPosition="left"
        class="w-100"
        :readonly="false"
        v-model="search"
        :placeholder="$t('integrations.iiko_menu_input.search_ph')"
      />
      <div class="search-results" v-if="search">
        <div
          class="search-result"
          v-for="(result, index) in searchResults"
          :key="index"
          @click="onSearchResultSelect(result)"
        >
          {{ result.name }} ({{ result.category }})
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlackInput from "@/components/BlackInput.vue";

export default {
  props: {
    value: [String, Number],
    show_logo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      search: null,
    };
  },
  methods: {
    onSearchResultSelect(item) {
      this.$emit("input", item.iiko_product_id);
      this.$emit("setData", item);
      this.search = null;
    },
    resetSelection() {
      this.$emit("input", null);
      this.search = null;
    },
  },
  computed: {
    searchResults() {
      if (!this.search) return [];

      const query = this.search.toLowerCase();

      const results = this.iikoList.filter((item) => {
        return (
          item.name.toLowerCase().includes(query) ||
          item.category.toLowerCase().includes(query)
        );
      });

      return results;
    },
    selectedProduct() {
      if (!this.value) return null;

      return this.iikoList.find((p) => p.iiko_product_id == this.value);
    },
    iikoList() {
      return this.$store.state.iiko.products_list;
    },
  },
  components: {
    BlackInput,
  },
};
</script>

<style scoped>
.iiko-input-wrapper {
  display: flex;
  column-gap: 8px;
}

.iiko-input-product {
  border: 1px solid #ededed;
  /* padding: 0.5vh; */
  border-radius: 0.5vh;

  border-top-right-radius: 0;
  border-bottom-right-radius: 0;

  background: #1d1d1b;

  display: flex;

  color: #ededed;
  cursor: pointer;
}

.iiko-product-input {
  background: white !important;
}

.iiko-input-product:hover {
  color: #e2223b;
}

.product-photo {
  width: 4vh;
  height: 4vh;
  min-width: 4vh;
  border-radius: 0.5vh;
  align-self: center;
}

.product-name {
  margin-left: 0.8vh;
  font-size: 1.7vh;
  align-self: center;
}

.iiko-input-search {
  width: 100%;
  background: white;
  font-size: 1.7vh;
  display: block;
  padding: 0.5vh;
  border: none;
  margin: 1.1vh 0;
  outline: none;
  -webkit-appearance: none;
  border-radius: 0.7vh;
}

.iiko-input-edit {
  position: relative;
  width: 100%;
}

.iiko-product-input {
  text-align: left;
}

.search-result {
  width: 100%;
  color: #1d1d1b;
  background: white;
  border-bottom: 1px solid #a4a4a4;
  cursor: pointer;
  padding: 0.3vh;
}

.search-result:hover {
  color: white;
  background: #416293;
}

.search-results {
  position: absolute;
  top: 3vh;
  z-index: 5;
}

.iiko-logo {
  width: 32px;
  height: 32px;
  max-width: 32px;
  border-radius: 6px;
  object-fit: cover;
}
</style>
